import { z } from 'zod';

import { BaseToolResultSchema } from './baseResult';

export const ELICIT_MISSING_CONTEXT_TOOL_NAME = 'elicit_missing_context' as const;

export const ElicitMissingContextCandidateSchema = z.object({
  assetId: z.string(),
  ext: z.string().optional(),
  filename: z.string().optional(),
  thumbnailUrl: z.string().optional(),
  versionId: z.string(),
});

export type ElicitMissingContextCandidate = z.infer<typeof ElicitMissingContextCandidateSchema>;

export const ElicitMissingContextSelectCandidateActionSchema = z.object({
  candidates: z.array(ElicitMissingContextCandidateSchema),
  type: z.literal('select_candidate'),
});

export type ElicitMissingContextSelectCandidateAction = z.infer<typeof ElicitMissingContextSelectCandidateActionSchema>;

export const ElicitMissingContextSearchWorkspaceActionSchema = z.object({
  exts: z.array(z.string()).optional(),
  searchMode: z.string().optional(),
  searchQuery: z.string(),
  type: z.literal('search_workspace'),
});

export const ElicitMissingContextUploadFileActionSchema = z.object({
  type: z.literal('upload_file'),
});

export const ElicitMissingContextSelectColorActionSchema = z.object({
  type: z.literal('select_color'),
});

export const ElicitMissingContextSelectFontActionSchema = z.object({
  type: z.literal('select_font'),
});

export const ElicitMissingContextActionSchema = z.discriminatedUnion('type', [
  ElicitMissingContextSelectCandidateActionSchema,
  ElicitMissingContextSearchWorkspaceActionSchema,
  ElicitMissingContextUploadFileActionSchema,
  ElicitMissingContextSelectColorActionSchema,
  ElicitMissingContextSelectFontActionSchema,
]);

export type ElicitMissingContextAction = z.infer<typeof ElicitMissingContextActionSchema>;

export const ElicitMissingContextResultSchema = BaseToolResultSchema.extend({
  actions: z.array(ElicitMissingContextActionSchema),
  contextSourceId: z.string(),
  // Exactly one of fieldId / fieldName is set — enforced by the backend tool.
  fieldId: z.string().optional(),
  fieldInstruction: z.string().optional(),
  fieldName: z.string().optional(),
  fieldType: z.enum(['file', 'color', 'font']),
  message: z.string(),
  status: z.string(),
  valueLabel: z.string().optional(),
});

export type ElicitMissingContextResult = z.infer<typeof ElicitMissingContextResultSchema>;
